
function Loading(){
    return(
        <h1>Please wait while I'm summarizing the article...</h1>
    )
}

export default Loading;
